var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconNewAnalysis(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1247",
    "data-name": "Group 1247",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2618",
    "data-name": "Rectangle 2618",
    width: 40,
    height: 40,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1246",
    "data-name": "Group 1246",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1163",
    "data-name": "Path 1163",
    d: "M37.859,40.162c9.565,0,12.988,8.227,13.577,9.876a.932.932,0,0,1,0,.627c-.588,1.649-4.009,9.874-13.577,9.874-9.47,0-12.966-8.223-13.571-9.871a.932.932,0,0,1,0-.635C24.875,48.385,28.3,40.162,37.859,40.162Zm11.7,10.19c-.77-1.955-3.88-8.325-11.7-8.325s-10.925,6.357-11.7,8.316c.791,1.961,3.957,8.331,11.7,8.331C45.684,58.675,48.793,52.307,49.562,50.352Z",
    transform: "translate(-18.101 -30.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1164",
    "data-name": "Path 1164",
    d: "M60.7,68.925a5.893,5.893,0,1,1,5.893-5.892A5.9,5.9,0,0,1,60.7,68.925ZM60.7,59a4.028,4.028,0,1,0,4.029,4.03A4.034,4.034,0,0,0,60.7,59Z",
    transform: "translate(-40.941 -42.682)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1165",
    "data-name": "Path 1165",
    d: "M.933,15.622A.932.932,0,0,1,0,14.689V5.244A5.249,5.249,0,0,1,5.244,0h9.5a.932.932,0,1,1,0,1.865h-9.5A3.382,3.382,0,0,0,1.865,5.244v9.446A.932.932,0,0,1,.933,15.622Z",
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1166",
    "data-name": "Path 1166",
    d: "M14.748,111.979h-9.5A5.249,5.249,0,0,1,0,106.736V97.292a.932.932,0,1,1,1.865,0v9.445a3.382,3.382,0,0,0,3.379,3.378h9.5a.932.932,0,0,1,0,1.865Z",
    transform: "translate(0 -71.98)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1167",
    "data-name": "Path 1167",
    d: "M111.219,15.622a.932.932,0,0,1-.932-.932V5.244a3.382,3.382,0,0,0-3.379-3.379H97.521a.932.932,0,0,1,0-1.865h9.387a5.249,5.249,0,0,1,5.243,5.243v9.446A.932.932,0,0,1,111.219,15.622Z",
    transform: "translate(-72.151 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    "data-name": "Path 1168",
    d: "M106.907,111.979H97.52a.932.932,0,0,1,0-1.865h9.387a3.382,3.382,0,0,0,3.379-3.378V97.292a.932.932,0,1,1,1.865,0v9.445A5.249,5.249,0,0,1,106.907,111.979Z",
    transform: "translate(-72.15 -71.98)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNewAnalysis);
export default __webpack_public_path__ + "static/media/icon-new-analysis.73a85bbc0b87b5bb40b5957a905e47a4.svg";
export { ForwardRef as ReactComponent };